export default __webpack_public_path__ + "static/garden_design11-c53187fec280c10a56acb68ff9388b3d.webp";